export const CYPRESS_KEYCLOAK_TOKEN = 'CYPRESS_KEYCLOAK_TOKEN';

export const KEYCLOAK_IDENTITY = 'KEYCLOAK_IDENTITY';

export const DEFAULT_MERCHANT = 'DEFAULT_MERCHANT';

export const COOKIE_CONSENT_COOKIE = 'OptanonAlertBoxClosed';

export const ALLOWED_HOSTS = ['localhost', 'portal.nonprod.klarna.net'];
